import { ACTION_TYPES } from '../actions'

const initialState = {}

export const matchDebitReducer = (state = initialState, action) => {
	switch (action.type) {
		case ACTION_TYPES.MATCH_DEBIT:
			return action.payload
		default:
			return state
	}
}
